export const formatUSPhoneNumber = (phoneNumber: string): string => {
  const cleaned = phoneNumber?.replace(/\D/g, '') || '';
  const match = cleaned.match(/^(?:1)?(\d{3})(\d{3})(\d{4})$/);
  return match ? `${match[1]}-${match[2]}-${match[3]}` : phoneNumber;
};

export const normalizePhoneNumber = (phoneNumber: string): string => {
  if (typeof phoneNumber === 'string') {
    return phoneNumber.replace(/\D/g, '');
  }

  return '';
};

export const formatPhoneOnType = (value: string): string => {
  const digits = value.replace(/\D/g, '');

  if (digits.length === 11 && digits.startsWith('1')) {
    const prefix = value.startsWith('+') ? '+' : '';
    return `${prefix}1-${digits.substring(1, 4)}-${digits.substring(
      4,
      7
    )}-${digits.substring(7)}`;
  }

  if (digits.length > 10) {
    return digits;
  }
  if (digits.length <= 3) {
    return digits;
  }
  if (digits.length <= 6) {
    return `${digits.substring(0, 3)}-${digits.substring(3)}`;
  }
  return `${digits.substring(0, 3)}-${digits.substring(
    3,
    6
  )}-${digits.substring(6)}`;
};
